<template>
  <div class="login-container">
    <el-form @submit.prevent="login" class="login-form" auto-complete="on" label-position="left">
      <div class="title-container">
        <img src="@/assets/img/logo.svg" width="300">
      </div>
      <p style="color:red; font-size: 14px;">{{errormsg}}</p>
      <el-form-item>
        <el-input v-model="user" placeholder="Email" type="text"/>
      </el-form-item>

      <el-form-item>
        <el-input v-model="pass" type="password" placeholder="Contraseña" show-password/>
      </el-form-item>

      <el-button type="primary" style="width:100%;margin-bottom:30px;" @click="login">Entrar</el-button>
      
      <div>
        <span style="margin-right:20px;"><router-link :to="{ name: 'Recovery' }">Recuperar contraseña</router-link></span>
        <!--<span><router-link :to="{ name: 'Register' }">Registrarse</router-link></span>-->
      </div>
    </el-form>
  </div>
</template>
<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      user: "",
      pass: "",
      errormsg: ""
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user, this.pass)
        .then(
          user => {
            this.$router.replace("/").catch(err => {});
          },
          error => {
            if( error.code === 'auth/wrong-password' )
              this.errormsg = 'La contraseña es incorrecta'
            else if ( error.code === 'auth/user-not-found' ) 
              this.errormsg = 'El usuario ingreado no existe'
            else if( error.code === 'auth/user-disabled')
              this.errormsg = 'El usuario está desactivado'
            else
              this.errormsg = 'Hubo un error, intente nuevamente'
          }
        )
    }
  }
};
</script>

<style>
a {
  text-decoration: none;
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}
.login-form {
  position: relative;
  max-width: 380px !important;
  width: auto !important;
  padding: 160px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}

</style>
